module.exports = __webpack_public_path__ + "img/BagicSvg1.48f2204c.svg";